import { date, util } from '@glu/core';
import DatePicker from '@glu/datepicker';
import FieldSearch from './fieldSearch';

export default FieldSearch.extend({
  className: 'date-range-search',
  today: new Date(), // saves execution in the filter method which gets called many times,
  startDate: null,
  endDate: null,

  ui: util.extend(FieldSearch.prototype.ui, {
    $dateInput: '.input-date'
  }),

  initialize() {
    this.parseFilterBadgeDates();
    this.filterDatePicker = this.createDatePicker();
    this.dateFormat = this.options.dateFormat || 'YYYY-MM-DD'; // todo. Not sure if we need it also here, if we have in model,
    // this.serverDateFormat = this.options.serverDateFormat || 'YYYY-MM-DD';

    // Not sure how better to handle events here
    // this.listenTo(this.filterDatePicker, 'datePicked', this.handleSubmitButton);
    this.listenTo(this, 'datePicked', this.handleSubmitButton);
  },

  parseFilterBadgeDates() {
    this.filterBadgeValue = this.model.get('value');

    if (this.filterBadgeValue) {
      // this.model.set('field-value', filterBadgeValue);
      const dates = this.filterBadgeValue.split(' - ');
      if (Array.isArray(dates) && dates.length > 0) {
        this.startDate = date(dates[0], this.model.get('dateFormat'));
        this.endDate = date(dates[1], this.model.get('dateFormat'));
      }
    }
  },

  onRender(...args) {
    this.renderDatePicker();
    FieldSearch.prototype.onRender.apply(this, args);
  },

  renderDatePicker() {
    this.ui.$focusField.replaceWith(this.filterDatePicker.render().$el);
    this.$el.find('input').addClass('form-control')
    // not sure if we need this.
    // but rather for compatibility with other dynamicTypeSearch.js entries
      .attr({
        id: 'field-value',
        name: 'field-value'
      });

    this.bindUIElements();
  },

  onClose() {
    if (this.filterDatePicker.view) {
      this.filterDatePicker.view.close();
    }
  },

  filter(field, value, model) {
    // var modelDate = date(model.get(field), this.dateFormat), // BAD (GLU-1352)
    const modelDate = model.get(field) ? date(model.get(field)) : null;
    // GOOD, because then MomentJs will properly convert. GLU-1314

    // convert everything to milliseconds for simple math comparison vs moment calls
    // which are both more verbose and much slower due to internal cloning
    const startMillis = this.startDate ? this.startDate.valueOf() : undefined;
    const endMillis = this.endDate ? this.endDate.valueOf() : undefined;
    const modelMillis = modelDate ? modelDate.valueOf() : undefined;

    // if we don't have a startDate then we have no filter so let everything match
    return (!startMillis || (modelMillis >= startMillis && modelMillis <= endMillis));
  },

  // Creates the date picker to be used for filtering grid data
  createDatePicker() {
    const options = {
      endDate: this.endDate, // we have to get start date from grid filterBadge if exists
      startDate: this.startDate,
      config: {
        locale: {}
      }
    };

    // assumed, it's from DynamicTypeSearch and there from column options. TODO - update glu-docs.
    if (this.model.has('datePickerConfig')) {
      // "config" object should follow/use/provide standard options from http://www.daterangepicker.com/
      options.config = this.model.get('datePickerConfig');
      // so that Glu Grid filter type date could pass all possible daterangepicker options.
    }

    // it's legacy code support - backwards compatibility.
    // dateFormat is deprecated. use instead config.locale.format
    if (this.model && this.model.has('dateFormat')) {
      options.config.locale.format = this.model.get('dateFormat');
    }

    return new DatePicker(options);
  },

  onDatePicked(datePicker, startDate, endDate) {
    this.startDate = startDate;
    this.endDate = endDate || startDate;
  },

  handleSubmitButton(...args) {
    // Note: first time this function called is from fieldSearch.js => getSelectValue(),
    // 2nd time from event 'datePicked'
    FieldSearch.prototype.handleSubmitButton.apply(this, args);

    const [selection] = args;

    if (!selection || !this.filterDatePicker.dateRangePicker) {
      return;
    }

    // selection var is different now
    // separator is not "to" but " - " - need to re-create processDateInput() here
    // But datePicker2.js built using daterangepicker, which already have startDate and
    // endDate as dedicated variable, so no need to split it but Glu.
    this.processDateInput(selection); // this is old datePicker.js code/function call !!!!
    // this.filterDatePicker.processDateInput(selection);
    // this is old datePicker.js code/function call !!!!

    // this is old datePicker.js hasError flag !!!!
    this.ui.$submitBtn.prop('disabled', this.filterDatePicker.hasError);

    // this is old datePicker.js hasError flag !!!!
    this.ui.$clearBtn.toggleClass('hidden', this.filterDatePicker.hasError);
  },

  // TODO maybe move to datepicker
  // If this function here, then filtering works
  // And this function looks more related to triggering
  // datePicked event for DateRangeSearch to notify Grid
  // TODO maybe move to datepicker
  processDateInput(/* selection */) {
    const lastStart = this.startDate ? this.startDate.valueOf() : null;
    const lastEnd = this.endDate ? this.endDate.valueOf() : null;
    const triggerFunctionName = this.triggerMethod ? 'triggerMethod' : 'trigger';
    // marionette based
    let curStart;
    let curEnd;

    // NOTE SURE
    this.startDate = this.filterDatePicker.dateRangePicker.startDate;
    this.endDate = this.filterDatePicker.dateRangePicker.endDate;

    if (this.hasError === false) {
      // Note: new Datepicker has .updateElement() which sets with separator, and formatted value
      curStart = this.startDate ? this.startDate.valueOf() : null;
      curEnd = this.endDate ? this.endDate.valueOf() : null;

      if (lastStart !== curStart || lastEnd !== curEnd) {
        // "this" is Marionette View, not a JQuery element
        this[triggerFunctionName]('datePicked', this, this.startDate, this.endDate);
      }
    }
  }
});
